import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkOperationsBar = ({ selectedCount, onBulkAssign, onBulkStatus, onBulkPriority, onBulkDelete, onClearSelection }) => {
  const [showStatusMenu, setShowStatusMenu] = useState(false);
  const [showPriorityMenu, setShowPriorityMenu] = useState(false);

  const statuses = ['Pending', 'In Progress', 'On Hold', 'Completed', 'Cancelled'];
  const priorities = ['Low', 'Medium', 'High', 'Critical'];

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-card border border-border rounded-xl shadow-elevation-3 px-4 py-3 flex items-center gap-3 flex-wrap justify-center">
      <div className="flex items-center gap-2 pr-3 border-r border-border">
        <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
          <span className="text-xs font-bold text-primary-foreground">{selectedCount}</span>
        </div>
        <span className="text-sm font-medium text-foreground">
          {selectedCount} ticket{selectedCount !== 1 ? 's' : ''} selected
        </span>
        <button
          onClick={onClearSelection}
          className="text-muted-foreground hover:text-foreground transition-smooth ml-1"
        >
          <Icon name="X" size={14} color="currentColor" />
        </button>
      </div>
      <Button
        variant="outline"
        size="sm"
        iconName="UserCog"
        iconPosition="left"
        onClick={onBulkAssign}
      >
        Assign
      </Button>
      <div className="relative">
        <Button
          variant="outline"
          size="sm"
          iconName="Activity"
          iconPosition="left"
          onClick={() => { setShowStatusMenu(p => !p); setShowPriorityMenu(false); }}
        >
          Status
          <Icon name="ChevronDown" size={14} color="currentColor" className="ml-1" />
        </Button>
        {showStatusMenu && (
          <div className="absolute bottom-full mb-2 left-0 bg-card border border-border rounded-lg shadow-elevation-2 py-1 min-w-[140px] z-10">
            {statuses?.map(status => (
              <button
                key={status}
                onClick={() => { onBulkStatus(status); setShowStatusMenu(false); }}
                className="w-full text-left px-3 py-2 text-sm text-foreground hover:bg-muted transition-smooth"
              >
                {status}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="relative">
        <Button
          variant="outline"
          size="sm"
          iconName="AlertCircle"
          iconPosition="left"
          onClick={() => { setShowPriorityMenu(p => !p); setShowStatusMenu(false); }}
        >
          Priority
          <Icon name="ChevronDown" size={14} color="currentColor" className="ml-1" />
        </Button>
        {showPriorityMenu && (
          <div className="absolute bottom-full mb-2 left-0 bg-card border border-border rounded-lg shadow-elevation-2 py-1 min-w-[140px] z-10">
            {priorities?.map(priority => (
              <button
                key={priority}
                onClick={() => { onBulkPriority(priority); setShowPriorityMenu(false); }}
                className="w-full text-left px-3 py-2 text-sm text-foreground hover:bg-muted transition-smooth"
              >
                {priority}
              </button>
            ))}
          </div>
        )}
      </div>
      <Button
        variant="destructive"
        size="sm"
        iconName="Trash2"
        iconPosition="left"
        onClick={onBulkDelete}
      >
        Delete
      </Button>
    </div>
  );
};

export default BulkOperationsBar;
